import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicProduct } from '../types';
import { updateClinicProducts } from '../requests';

type UpdateClinicProduct = (updates: ClinicProduct[], clinicId: string) => Promise<void>;

interface UseUpdateClinicProductReturn {
  updateClinicProducts: UpdateClinicProduct
  isLoading: boolean;
}

export const useUpdateClinicProducts = (): UseUpdateClinicProductReturn => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ([updates, clinicId]: [ClinicProduct[], string]) => updateClinicProducts(updates, clinicId),
    onSuccess: () => {
      queryClient.invalidateQueries(['clinic-products']);
    }
  });

  const updateClinicProductsCallback = async (cps: ClinicProduct[], clinicId: string) => {
    await mutateAsync([cps, clinicId]);
  };

  return { updateClinicProducts: updateClinicProductsCallback, isLoading };
};
